import Hero from './components/Hero';
import StoryIntro from './components/StoryIntro';
import PlotPreview from './components/PlotPreview';
import CharacterPreview from './components/CharacterPreview';
import EpisodePreview from './components/EpisodePreview';
import FaqPreview from './components/FaqPreview';
import CTABand from './components/CTABand';
import { usePageMeta } from '@/hooks/usePageMeta';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      name: '泡在我家的辣妹资料站',
      description: '泡在我家的辣妹漫画剧情介绍、故事主线与核心设定',
      inLanguage: 'zh-CN',
    },
    {
      '@type': 'WebPage',
      name: '泡在我家的辣妹 - 漫画剧情介绍、故事主线与核心设定',
      inLanguage: 'zh-CN',
      isPartOf: { '@type': 'WebSite', name: '泡在我家的辣妹资料站' },
    },
  ],
};

export default function Home() {
  usePageMeta({
    title: '泡在我家的辣妹 - 漫画剧情介绍、故事主线与核心设定',
    description:
      '泡在我家的辣妹漫画剧情到底讲了什么？这里汇总泡在我家的辣妹故事主线、漫画介绍与核心设定，帮你快速理清分集剧情走向，看漫画前先补课，追更不迷路。',
    keywords:
      '泡在我家的辣妹,泡在我家的辣妹漫画剧情,泡在我家的辣妹故事,泡在我家的辣妹讲什么,泡在我家的辣妹漫画介绍,泡在我家的辣妹设定,泡在我家的辣妹分集剧情',
    canonicalPath: '/',
    jsonLd,
  });

  return (
    <>
      <Hero />
      <StoryIntro />
      <PlotPreview />
      <CharacterPreview />
      <EpisodePreview />
      <FaqPreview />
      <CTABand />
    </>
  );
}